<div class="menu">
    <span class="menu-heading">{{fileName}}</span>
    <span class="close" (click)="closePreviewPopup()">X</span>
</div>
  <div class="">
    <div class="title-wrapper">
        <span class="action-name">Download Preview</span>
    </div>
    <ng-container *ngIf="fileUrl; else noFile">
      <iframe style="border:none;" type="application/pdf"
       [src]="'url(' + safeUrl + ')'" width="100%" height="300px"></iframe>
        
    </ng-container>
    <ng-template #noFile>
      <div class="">No preview available for this file.</div>
    </ng-template>
  </div>
<div class="menu-bottom text-center">
    
    <button class="main-btn large" (click)="downloadFile()">
    <img class="download-icon" src="{{ baseHref }}/assets/images/icon-download.png" />
        Download
    </button>
</div>
